export default {
	name: 'subjectFeedbackDetail',
	data() {
		return {
			ShopSubjectID: 0,
			getData: {},
			subject: {
				PayMoney: 0,
				isEnd: true
			},
			subjectCustomer: [],
			type: 0,
			TeacherComment: '',
			img: '',
			fileName: '',
			file: '',
			subjecCutomerFeedBack: {},
			submitfeedBack: {},
			Edit: ''
		};
	},
	created() {
		this.getData = () => {
			this.ShopSubjectID = this.$route.params.ShopSubjectID;
			this.$request.request({
				url: 'Shops/getShopSubject',
				data: {
					ShopSubjectID: this.ShopSubjectID
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					this.subject = r.subject;
					this.subjectCustomer = r.subjectCustomer;
				}
			});
		}
		this.getData();
		this.submitfeedBack = () => {
			let param = new FormData()
			param.append('userCode', this.$store.state.user.UserCode);
			param.append('teacherID', this.$store.state.user.UserID);
			param.append('type', this.type);
			param.append('teacherComment', this.TeacherComment);
			param.append('fileName', this.fileName);
			param.append('ShopSubjectID', this.ShopSubjectID);
			param.append('SubjectCustomerID', this.type == 0 ? 0 : this.subjecCutomerFeedBack.SubjectCustomerID);
			if (this.file != '')
				param.append('file', this.file);
			this.$request.upLoadFile({
				url: 'borrowAndReturn/subjectFeedBack',
				data: param,
				method: 'post'
			}).then(res => {
				this.Edit = '';
				this.img = "";
				this.file = '';
				this.fileName = "";
				if (res.result) {
					this.$uil.showMessage({
						text: res.message
					});
					this.getData();
				}
			});
		}
	},
	methods: {
		feedBack(i, type) {
			this.type = type;
			if (type == 1) {
				this.TeacherComment = i.TeacherComment;
				this.subjecCutomerFeedBack = i;
				this.fileName = i.SubjectCustomerimg;
			} else {
				this.TeacherComment = this.subject.TeacherComment;
				this.fileName = this.subject.SubjectEndimg;
			}
			if (this.fileName != undefined && this.fileName != '' && this.fileName !=
				null) {
				this.img = this.$store.state.baseURL.replace('/api', '') + 'subjectImg/' + this.fileName;
			} else {
				this.img = "";
				this.fileName = "";
				this.file = '';
			}
			this.Edit = 'update';
		},
		selectFile(e) {
			let camear = this.$refs.camear;
			camear.click();
			let img = this.$refs.camear;
			let that = this;
			camear.onchange = function() {
				that.file = this.files[0];
				that.fileName = this.files[0].name;
				var reader = new FileReader();
				reader.readAsDataURL(this.files[0]);
				reader.onload = function() {
					that.img = this.result;
				};
			};
		},
	},
	computed: {
		checkFile() {
			if (this.fileName == '') return '请选择图片';
			let index = this.fileName.lastIndexOf('.');
			if (index == -1) return '格式错误';
			let ext = this.fileName.substring(index + 1);
			if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) == -1)
				return '格式错误';
			else
				return '';


		}
	},
	filters: {
		rmb(v) {
			return v + '¥';
		}
	},
	activated() {
		this.getData();
	}
}
